module.exports = __webpack_public_path__ + "img/icon-cart.f206b080.svg";